import React, { useContext, useEffect, useState, useCallback } from "react";
import { AuthContext } from "../../context/AuthContext";
import { useMessage } from "../../context/MessageContext";
import * as S from "./ExtratoValorizacaoStyle";
import Loading from "../Loading/Loader";
import TabelaValorizacao from "../Tabelas/TabelaValorizacao";
import SideBarBox from "../Sidebar/SideBarBox";
import { valorizationService } from "../../Services/valorizationService"; // <-- Importando o novo serviço

const ExtratoValorizacao = () => {
  const { userData } = useContext(AuthContext);
  const { showMessage } = useMessage();

  const [historico, setHistorico] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [filtroContratoId, setFiltroContratoId] = useState("");
  const [filtroData, setFiltroData] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);

  const fetchHistory = useCallback(
    async (page = 1) => {
      if (!userData?.id) return;

      setIsLoading(true);
      try {
        const filters = {
            clientId: userData.id,
            page: page,
            contractId: filtroContratoId,
            date: filtroData,
        };
        // Usando o serviço para buscar o histórico
        const responseData = await valorizationService.searchHistory(filters);
        
        setHistorico(responseData.items || []);
        setCurrentPage(responseData.page);
        setTotalPages(responseData.totalPages);
      } catch (error) {
        console.error("Erro ao buscar histórico:", error);
        showMessage("Não foi possível carregar o histórico.", "error");
        setHistorico([]);
      } finally {
        setIsLoading(false);
      }
    },
    [userData?.id, filtroContratoId, filtroData, showMessage]
  );

  useEffect(() => {
    fetchHistory(1);
  }, [fetchHistory]); // A dependência agora é a própria função memoizada

  const handleFilter = () => {
    fetchHistory(1);
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleFilter();
    }
  };
  
  // O JSX permanece o mesmo
  return (
    <SideBarBox>
      <S.PageContainer>
        {isLoading && <Loading load={isLoading} />}
        <S.Header>
          <h1>Extrato de Valorização</h1>
          <p>Acompanhe a valorização diária de seus contratos.</p>
        </S.Header>
        <S.FilterContainer>
          <S.FilterGroup>
            <label>Filtrar por Contrato</label>
            <input
              type="number"
              placeholder="Digite o ID do contrato"
              value={filtroContratoId}
              onChange={(e) => setFiltroContratoId(e.target.value)}
              onKeyPress={handleKeyPress}
            />
          </S.FilterGroup>
          <S.FilterGroup>
            <label>Filtrar por Data</label>
            <input
              type="date"
              value={filtroData}
              onChange={(e) => setFiltroData(e.target.value)}
              onKeyPress={handleKeyPress}
            />
          </S.FilterGroup>
          <S.FilterButton onClick={handleFilter}>
            Aplicar Filtros
          </S.FilterButton>
        </S.FilterContainer>

        <TabelaValorizacao
          historico={historico}
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={fetchHistory}
        />
      </S.PageContainer>
    </SideBarBox>
  );
};

export default ExtratoValorizacao;